import React, { useEffect, useRef, useState } from "react";
import SelectBox from "../../../../components/elements/form/selectBox";
import { useSpearPartsApi } from "../../../../store/api/hooks/spearPartsApiHook";
import { useCommonApi } from "../../../../store/api/hooks/commonApiHook";

interface CreatePurchasedRequestPartsProps {
    data: Array<any>;
    onUpdate?: (data: Array<any>) => void;
}
const CreatePurchaseRequestParts: React.FC<CreatePurchasedRequestPartsProps> = ({ data, onUpdate = (data: Array<any>) => { } }) => {
    const divRef = useRef<any>(null);
    const sparePartsAPI = useSpearPartsApi();
    const commonApi: any = useCommonApi();
    const blankpartmodel = {
        partsID: null,
        vendorPartCode: ``,
        vendorPartName: ``,
        vendorID: null,
        vendorName: ``,
        requiredQty: 0,
        unitID: null,
        unitPrice: 0,
        unitName: ``,
        totalAmount: 0,
        isEdit: false
    };

    const [partsItems, setPartsItems] = useState<any[]>(data || []);
    const [vendorList, setVendorList] = useState<any[]>([]);

    const onOutsideClick = () => {
        handleOnClickCellEdit()
    }

    const handleOnClickCellEdit = (identifier: string = ``, e: any = null) => {
        if (identifier) {
            const cellElement = document.querySelector(`#${identifier}`) as HTMLDivElement;
            const previewElement = cellElement.querySelector(`.preview-value`) as HTMLDivElement;
            const editElement = cellElement.querySelector(`.edit-value`) as HTMLDivElement;
            if (previewElement && editElement) {
                if (cellElement.id === `${identifier}`) {
                    if (!previewElement.classList.contains(`hidden`)) previewElement.classList.add(`hidden`);
                    if (editElement.classList.contains(`hidden`)) editElement.classList.remove(`hidden`);
                }
            }
        }

        //resetOthersCellEditState(`part-item-name-${index}`);
        const editableList = document.querySelectorAll(`.editable`) as NodeListOf<HTMLDivElement>
        //console.log("editableList", editableList);
        for (let i = 0; i < editableList.length; i++) {
            const editableCell = editableList[i];
            const preview = editableCell.querySelector(`.preview-value`) as HTMLDivElement;
            const edit = editableCell.querySelector(`.edit-value`) as HTMLDivElement;
            if (editableCell.id !== `${identifier}`) {
                if (preview.classList.contains(`hidden`)) preview.classList.remove(`hidden`);
                if (!edit.classList.contains(`hidden`)) edit.classList.add(`hidden`);
            }
        }

    };

    const handlePartsSearch = async (inputval: any): Promise<any[]> => {
        return new Promise((resolve, reject) => {
            sparePartsAPI.getSpearPartsList({
                pageSize: 10,
                pageNumber: 1,
                searchParam: inputval,
            }, (resp: any) => {
                if (resp && resp.code === 200 && resp.successful === true && resp.hasOwnProperty(`sparePartsList`) && Array.isArray(resp.sparePartsList) && resp.sparePartsList.length > 0) {
                    const bindParts = resp.sparePartsList.map((part: any) => {
                        return {
                            ...part,
                            value: part.partsCode,
                            label: part.sparePartsName,
                        };
                    });
                    resolve(bindParts);
                } else {
                    resolve([]);
                }
            }, (error: any) => {
                reject([])
            })
        });
    };

    const handleVendorSearch = async (inputval: any): Promise<any[]> => {        
        return new Promise((resolve, reject) => {            
            commonApi.GetServiceprovidertList({}, (resp: any) => {
                if (resp && resp.hasOwnProperty(`vendorList`) && Array.isArray(resp.vendorList) && resp.vendorList.length > 0 ) {
                    /*
                    const deptlist = resp.vendorList.map((user: any) => {
                        return {
                            label: user.name,
                            value: user.vendorID,
                        };
                    });
                    resolve(deptlist);
                    */
                    resolve(resp.vendorList);
                } else {
                    resolve([]);
                }
            }, (error: any) => {
                reject([])
            })
        });
    };

    const init_page_data = async () => {
        const vendorlist = await handleVendorSearch(``);
        setVendorList(vendorlist);
        onUpdate(partsItems);
    };

    useEffect(() => {
        // set dummy data
        init_page_data();   
        console.log("Line items data is -> ", data, partsItems);         
    }, []);

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (divRef.current && !divRef.current.contains(event.target)) {
                onOutsideClick();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onOutsideClick]);

    useEffect(() => {
        const handleKeyDown = (event: any) => {
            if (event.key === 'Escape') {
                onOutsideClick();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [onOutsideClick]);


    return (
        <div>
            <div className="flex justify-between items-center mt-1">
                <h4 className='font-semibold text-[0.938rem] py-4 uppercase'>ITEMS</h4>
                <button type={ `button` } className='text-primary' onClick={() => {
                    const newPart = Object.assign({}, JSON.parse(JSON.stringify(blankpartmodel)));
                    setPartsItems([...partsItems, newPart]);
                    onUpdate([...partsItems, newPart]);
                }}>Add parts</button>
            </div>
            {/* total width 650px */}
            <div className={`border border-[#043E6133] rounded-[5px] parts-table`}>
                <div className={`flex items-center flex-nowrap bg-[#F0F0F0] rounded-ss-[5px] rounded-se-[5px]`}>
                    <div className={`w-48 min-w-48 max-w-48 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center`}>Item Code</div> {/* 144px */}
                    <div className={`w-[284px] min-w-[284px] max-w-[284px] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center`}>Item Name</div> {/* 270px */}
                    <div className={`w-28 min-w-28 max-w-28 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center justify-end`}>Est Cost</div> {/* 112px */}
                    <div className={`w-36 min-w-36 max-w-36 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center justify-end`}>Required Quantity</div> {/* 144px */}
                    <div className={`w-28 min-w-28 max-w-28 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] grow flex items-center justify-end`}>Total Cost</div> {/* 112px */}
                    <div className={`w-8 min-w-8 max-w-8 font-semibold text-[#262A2D] text-[13px] px-0 py-2 h-[50px] flex items-center`}> </div> {/* 32px */}
                </div>
                <div className={``} ref={divRef}>
                    {partsItems.length === 0 && (
                        <div className={`flex items-center justify-center h-24 text-gray-500`}>
                            No parts added yet.
                        </div>
                    )}
                    {partsItems.map((part, index) => (                        
                        <div className={`flex items-center flex-nowrap ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`} key={`part-item-${index}`}>
                            <div className={`w-48 min-w-48 max-w-48 font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex items-center bg-[#F9F9F9] cursor-not-allowed`}>
                                <div className={`line-clamp-1 text-ellipsis`}>{part.vendorPartCode || `--`}

                                </div>
                            </div>
                            <div className={`w-[284px] min-w-[284px] max-w-[284px] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable`} id={`part-item-name-${index}`} onClick={(e: any) => {
                                handleOnClickCellEdit(`part-item-name-${index}`, e);
                                e.stopPropagation();
                                e.preventDefault();
                            }}>
                                <div className={`preview-value line-clamp-1`} title={part.vendorName?part.vendorName: `Click here to add data`}>{part.vendorPartName || `--`}</div>
                                <div className={`edit-value hidden`}>
                                    <SelectBox
                                        label={``}
                                        value={part? { label: part.vendorPartName, value: part.vendorPartCode }: null}
                                        onChange={(value: any) => {
                                            console.log("Selected part: ", value);                                            
                                            const updatedParts = [...partsItems];                                            
                                            updatedParts[index].vendorPartName = value?.label || ``; // Assuming value has a label property
                                            updatedParts[index].vendorPartCode = value?.value || ``; // Assuming value has a value property
                                            updatedParts[index].partsID = value?.partsID || null;
                                            updatedParts[index].unitPrice = value?.pricePerUnit || 0;
                                            updatedParts[index].unitID = value?.unitID || null;
                                            updatedParts[index].unitName = value?.unitCode || `--`;
                                            updatedParts[index].totalAmount = (updatedParts[index].unitPrice || 0) * (updatedParts[index].requiredQty || 0);                                            
                                            setPartsItems(updatedParts);
                                            onUpdate(updatedParts);
                                        }}
                                        required
                                        placeholder='Search & Select Part'
                                        options={[]}
                                        className={`!my-0`}
                                        customStyleOption={{ control: (base) => ({ ...base, marginTop: `0rem`, minHeight: '32px' }) }}
                                        async={true}
                                        isClearable={true}
                                        asyncLoadOptions={async (inputValue: string) => {                                            
                                            return handlePartsSearch(inputValue);
                                        }}
                                    />
                                </div>
                            </div>
                            {/* Est Cost - Editable */}
                            <div className={`w-28 min-w-28 max-w-28 font-normal text-[#42484B] text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col editable cursor-pointer`} id={`part-item-estcost-${index}`} onClick={(e: any) => {
                                handleOnClickCellEdit(`part-item-estcost-${index}`, e);
                                e.stopPropagation();
                                e.preventDefault();
                            }}>
                                <div className={`text-right`}>
                                    <div className={`preview-value`} title={(+part.unitPrice > 0)? (`Est Cost: ` + part.unitPrice): `Click here to add data`}>{part.unitPrice || 0}</div>
                                    <div className={`edit-value hidden`}>
                                        <input
                                            type="number"
                                            name={`estCost${index}`}
                                            className={`w-full border border-gray-300 rounded px-2 py-1 outline-none text-right input-no-spinner`}
                                            value={part.unitPrice}
                                            min={0}
                                            step="0.01"
                                            onInput={(e: any) => {
                                                const newPrice = e.target.value;
                                                const updatedParts = [...partsItems];
                                                updatedParts[index].unitPrice = newPrice;
                                                updatedParts[index].totalAmount = (parseFloat(newPrice) || 0) * (updatedParts[index].requiredQty || 0);
                                                setPartsItems(updatedParts);
                                                onUpdate(updatedParts);
                                            }}
                                            onBlur={(e: any) => {
                                                const newPrice = parseFloat(e.target.value);
                                                const updatedParts = [...partsItems];
                                                updatedParts[index].unitPrice = isNaN(newPrice) ? 0 : (newPrice > -1 ? newPrice : 0);
                                                updatedParts[index].totalAmount = (updatedParts[index].unitPrice || 0) * (updatedParts[index].requiredQty || 0);
                                                setPartsItems(updatedParts);
                                                onUpdate(updatedParts);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={`w-36 min-w-36 max-w-36 font-normal text-[#42484B] text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col editable cursor-pointer`} id={`part-item-qty-${index}`} onClick={(e: any) => {
                                handleOnClickCellEdit(`part-item-qty-${index}`, e);
                                e.stopPropagation();
                                e.preventDefault();
                            }}>
                                <div className={`flex items-center gap-1 flex-nowrap justify-end`}>
                                    <div className={`w-20 min-w-20 text-right`}>
                                        <div className={`preview-value`} title={(+part.requiredQty > 0)? (`Quantity is: ` + part.requiredQty): `Click here to add data`}>{part.requiredQty || 0}</div>
                                        <div className={`edit-value hidden`}>
                                            {[1,5].includes(+part.unitID)? (
                                                <input
                                                    type="tel"
                                                    className={`w-full border border-gray-300 rounded px-2 py-1 outline-none text-right`}
                                                    value={part.requiredQty}
                                                    onChange={(e) => {
                                                        const newQty = +e.target.value;
                                                        const updatedParts = [...partsItems];
                                                        updatedParts[index].requiredQty = isNaN(newQty) ? 0 : newQty;
                                                        updatedParts[index].totalAmount = (updatedParts[index].unitPrice || 0) * (updatedParts[index].requiredQty || 0);
                                                        setPartsItems(updatedParts);
                                                        onUpdate(updatedParts);
                                                    }}
                                                />
                                            ): (
                                                <input
                                                    type="number"
                                                    name={`requiredQtyxx${index}`}
                                                    className={ `w-full border border-gray-300 rounded px-2 py-1 outline-none text-right input-no-spinner` }
                                                    value={part.requiredQty}
                                                    min={0}                                        
                                                    onInput={(e:any) => {
                                                        const newQty = e.target.value;
                                                        const updatedParts = [...partsItems];
                                                        //console.log(e.target.value);                                                                                                
                                                        //console.log(newQty);
                                                        //updatedParts[index].unitPrice = isNaN(newQty) ? 0 : newQty;
                                                        updatedParts[index].requiredQty = newQty;
                                                        updatedParts[index].totalAmount = (updatedParts[index].unitPrice || 0) * (parseFloat(newQty) || 0);
                                                        setPartsItems(updatedParts);
                                                        onUpdate(updatedParts);                                                
                                                    }}
                                                    onBlur={(e:any) => {
                                                        const newQty = e.target.value;
                                                        const updatedParts = [...partsItems];
                                                        updatedParts[index].requiredQty = isNaN(newQty) ? 0 : (+newQty > -1? +newQty: 0);
                                                        updatedParts[index].totalAmount = (updatedParts[index].unitPrice || 0) * (updatedParts[index].requiredQty || 0);
                                                        setPartsItems(updatedParts);
                                                        onUpdate(updatedParts);
                                                    }}
                                                    /*
                                                    onChange={(e) => {                                                    
                                                        const newQty = +e.target.value;
                                                        const updatedParts = [...partsItems];
                                                        updatedParts[index].requiredQty = isNaN(newQty) ? 0 : newQty;
                                                        setPartsItems(updatedParts);
                                                        onUpdate(updatedParts);
                                                    }}
                                                    */
                                                />
                                            )}                                            
                                        </div>
                                    </div>
                                    <div>{part.unitName || `--`}</div>
                                </div>
                            </div>
                            {/* Total Cost - Calculated (Est Cost * Required Quantity) */}
                            <div className={`w-28 min-w-28 max-w-28 font-normal text-[#42484B] text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex items-center justify-end bg-[#F9F9F9] cursor-not-allowed`}>
                                <div className={`text-right`}>{((part.unitPrice || 0) * (part.requiredQty || 0)).toFixed(2)}</div>
                            </div>
                            <div className={`w-8 min-w-8 max-w-8 font-normal text-[#42484B] text-[15px] px-2.5 py-3`}>
                                <a onClick={() => {
                                    const updatedParts = [...partsItems];
                                    updatedParts.splice(index, 1);
                                    setPartsItems(updatedParts);
                                    onUpdate(updatedParts);
                                }}>
                                    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect y="0.500977" width="15.0008" height="15" rx="7.5" fill="#E6BDCB" />
                                        <path d="M10.8974 10.9032C10.93 10.9357 10.9557 10.9743 10.9733 11.0168C10.9909 11.0593 11 11.1048 11 11.1508C11 11.1968 10.9909 11.2423 10.9733 11.2848C10.9557 11.3273 10.93 11.3659 10.8974 11.3984C10.8649 11.4309 10.8263 11.4567 10.7838 11.4743C10.7413 11.4919 10.6958 11.501 10.6498 11.501C10.6038 11.501 10.5583 11.4919 10.5158 11.4743C10.4733 11.4567 10.4347 11.4309 10.4022 11.3984L7.5 8.49576L4.59779 11.3984C4.53212 11.4641 4.44305 11.501 4.35018 11.501C4.2573 11.501 4.16823 11.4641 4.10256 11.3984C4.03689 11.3327 4 11.2437 4 11.1508C4 11.0579 4.03689 10.9689 4.10256 10.9032L7.00521 8.00098L4.10256 5.09876C4.03689 5.03309 4 4.94402 4 4.85115C4 4.75828 4.03689 4.66921 4.10256 4.60354C4.16823 4.53787 4.2573 4.50098 4.35018 4.50098C4.44305 4.50098 4.53212 4.53787 4.59779 4.60354L7.5 7.50619L10.4022 4.60354C10.4679 4.53787 10.557 4.50098 10.6498 4.50098C10.7427 4.50098 10.8318 4.53787 10.8974 4.60354C10.9631 4.66921 11 4.75828 11 4.85115C11 4.94402 10.9631 5.03309 10.8974 5.09876L7.99478 8.00098L10.8974 10.9032Z" fill="#F31260" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    ))}

                </div>
            </div>            

        </div>
    );
};
export default CreatePurchaseRequestParts;